import { createContext, useContext, useState, useCallback } from "react";

const NotesContext = createContext(null);

export function NotesProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [scope, setScope] = useState({ context: "general", context_label: "", context_ref: "" });

  const openNotes = useCallback((context = "general", context_label = "", context_ref = "") => {
    setScope({ context, context_label, context_ref });
    setOpen(true);
  }, []);

  return (
    <NotesContext.Provider value={{ open, setOpen, scope, openNotes }}>
      {children}
    </NotesContext.Provider>
  );
}

export const useNotes = () => useContext(NotesContext);
